__turbopack_context__.v({
  "description": "styles-module-scss-module__DawWqq__description",
  "empty": "styles-module-scss-module__DawWqq__empty",
  "header": "styles-module-scss-module__DawWqq__header",
  "outer": "styles-module-scss-module__DawWqq__outer",
  "pagination": "styles-module-scss-module__DawWqq__pagination",
  "pagination__active": "styles-module-scss-module__DawWqq__pagination__active",
  "pagination__disabled": "styles-module-scss-module__DawWqq__pagination__disabled",
  "row": "styles-module-scss-module__DawWqq__row",
  "row__big": "styles-module-scss-module__DawWqq__row__big",
  "title": "styles-module-scss-module__DawWqq__title",
  "wrapper": "styles-module-scss-module__DawWqq__wrapper",
});
